import React, { useRef, useState } from "react";
import { casinoPageData } from "../../../../lib/data";
import { useSelector } from "react-redux";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import Header from "../../../../containers/Header";
import { Button, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import PlayIcon from "../../../../assets/images/icons/play-icon.svg";
import NextBack from "../../../../assets/images/icons/right-arrow.png";
import BeforeLoginFooter from "../../../../containers/BeforeLoginFooter";
import Footer from "../../../../containers/Footer";
import GamesSearchModal from "../../../components/GamesSearchModal";
import MainSlider from "../../../../containers/MainSlider";
import Search from "../../../../assets/images/icons/search.webp";
import useScrollTabs from "../../../../hooks/useScrollTabs";
import LeftBarSports from "../../../components/LeftBarSports";

const AllKey = "all";

export const casinoTabsData = [
  {
    id: 0,
    name: "Lobby",
    key: "lobbies",
    img: "/images/icons/providers/lobby.webp",
    showMobile: false,
  },
  {
    id: 1,
    name: "All Games",
    key: AllKey,
    img: "/images/icons/providers/allgames.png",
    showMobile: false,
  },
  {
    id: 2,
    name: "Crash",
    key: "crashGames",
    img: "/images/icons/providers/crash.webp",
    showMobile: false,
  },
  {
    id: 3,
    name: "Slots",
    key: "slots",
    img: "/images/icons/providers/slots.webp",
    showMobile: false,
  },
  {
    id: 4,
    name: "Jili",
    key: "jili",
    img: "/images/icons/providers/jili.webp",
    showMobile: true,
  },
  {
    id: 5,
    name: "Pocket Games Soft",
    key: "pocketGamesSoft",
    img: "/images/icons/providers/pocketgames.webp",
    showMobile: true,
  },
  {
    id: 6,
    name: "Asia Gaming",
    key: "asiaGaming",
    img: "/images/icons/providers/asiagaming.webp",
    showMobile: true,
  },
  {
    id: 7,
    name: "Bet Games",
    key: "betGames",
    img: "/images/icons/providers/betgames.webp",
    showMobile: true,
  },
  {
    id: 8,
    name: "Fishing Games",
    key: "fishingGames",
    img: "/images/icons/providers/fishinggames.webp",
    showMobile: true,
  },
  // {
  //   id: 9,
  //   name: "Spribe",
  //   key: "spribe",
  //   img: "/images/icons/providers/spribe.webp",
  //   showMobile: false,
  // },
  {
    id: 10,
    name: "Mac88",
    key: "mac88",
    img: "/images/icons/providers/mac88.webp",
    showMobile: true,
  },
  {
    id: 11,
    name: "Mac88 Virtuals",
    key: "mac88VR",
    img: "/images/icons/providers/mac88vr.webp",
    showMobile: true,
  },
  {
    id: 12,
    name: "SmartSoft Gaming",
    key: "smartSoft",
    img: "/images/icons/providers/smartsoft.webp",
    showMobile: true,
  },
  {
    id: 13,
    name: "NetEnt",
    key: "netent",
    img: "/images/icons/providers/netent.webp",
    showMobile: true,
  },
  {
    id: 14,
    name: "Red Tiger",
    key: "redtiger",
    img: "/images/icons/providers/redtiger.webp",
    showMobile: false,
  },
  {
    id: 15,
    name: "Pragmatic Play",
    key: "pragmaticplay",
    img: "/images/icons/providers/pragmaticplay.png",
    showMobile: false,
  },
  {
    id: 16,
    name: "Instant Win",
    key: "instantWin",
    img: "/images/icons/providers/instantwin.webp",
    showMobile: false,
  },
  {
    id: 17,
    name: "Hacksaw",
    key: "hacksaw",
    img: "/images/icons/providers/hacksaw.webp",
    showMobile: false,
  },
  {
    id: 18,
    name: "Turbo",
    key: "turbo",
    img: "/images/icons/providers/turbo.webp",
    showMobile: false,
  },
  {
    id: 19,
    name: "Play'n Go",
    key: "playNGo",
    img: "/images/icons/providers/playngo.webp",
    showMobile: false,
  },
  {
    id: 20,
    name: "Relax Gaming",
    key: "relaxGaming",
    img: "/images/icons/providers/relaxgaming.webp",
    showMobile: false,
  },
  {
    id: 21,
    name: "Habanero",
    key: "habanero",
    img: "/images/icons/providers/habanero.webp",
    showMobile: false,
  },
  {
    id: 22,
    name: "Dragoon Soft",
    key: "dragoonSoft",
    img: "/images/icons/providers/dragoonsoft.webp",
    showMobile: false,
  },
];

const Casino = () => {
  const { banners } = useSelector((state) => state.app);
  const navigate = useNavigate();
  const { isAuth } = useSelector((state) => state.auth);
  const [activeSection, setActiveSectioon] = useState(AllKey);
  const [searchArray, setSearchArray] = useState([]);
  const gameListRefs = useRef({});
  const tabsRef = useRef({});
  const { appDetails } = useSelector((state) => state.app);
  const { scrollRef: gameListRef, scrollTabs: scrollGameList } =
    useScrollTabs();

  const handleRedirection = (item) => {
    // if (!isAuth) {
    //   navigate("/");
    //   return;
    // }

    window.open(item?.href);
  };

  const handleSearch = (value) => {
    if (!value) {
      setSearchArray([]);
      return;
    }

    let searchedValue = [];

    Object.values(casinoPageData)?.map((firstObject) => {
      Object.values(firstObject).map((secondObj) => {
        searchedValue = [
          ...searchedValue,
          ...Object.values(secondObj).filter(
            (f) => f?.name?.toLowerCase()?.indexOf(value?.toLowerCase()) > -1,
          ),
        ];
      });
    });

    setSearchArray(searchedValue);
  };

  //   const extractDeepObjects = (obj) => {
  //     const result = [];

  //     const traverse = (node, key = "") => {
  //       if (typeof node === "object" && node !== null) {
  //         const keys = Object.keys(node);

  //         // If it has children that are also objects, continue traversing
  //         if (keys.some((k) => typeof node[k] === "object")) {
  //           keys.forEach((k) => traverse(node[k], k));
  //         } else {
  //           // It's the deepest level, push to result
  //           result.push({ id: key, ...node });
  //         }
  //       }
  //     };

  //     traverse(obj);
  //     return result;
  //   };

  const handleScroll = (key, direction) => {
    const list = gameListRefs.current[key];
    if (list) {
      list.scrollBy({
        left: direction === "next" ? 300 : -300,
        behavior: "smooth",
      });
    }
  };

  const handleTabsScroll = (direction) => {
    if (tabsRef.current) {
      tabsRef.current.scrollBy({
        left: direction === "next" ? 300 : -300,
        behavior: "smooth",
      });
    }
  };

  const getTabDetails = (actvKey) => {
    return casinoTabsData?.find((f) => f?.key === actvKey);
  };

  function NextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block", background: "red" }}
        onClick={onClick}
      />
    );
  }

  function PrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block", background: "green" }}
        onClick={onClick}
      />
    );
  }

  const settings = {
    dots: true,
    arrows: true,
    autoplay: false,
    infinite: true,
    speed: 80,
    slidesToShow: 10,
    slidesToScroll: 5,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <>
      <main className="main pt-0">
        <div className="home-section">
          <div className="left-section">
            <LeftBarSports />
          </div>
          <div className="right-section">
            <div className="mainBanner mb-4">
              <MainSlider banners={banners} />
            </div>

            <div className="live-casino">
              <div className="container category-filter">
                <div className="tabs-box">
                  {/* <div className="btn-box">
                <Button
                  variant="primary"
                  className="back-btn"
                  onClick={() => handleTabsScroll("back")}
                >
                  <img src={NextBack} alt="beack game" />
                </Button>
              </div> */}
                  <ul className="tabs" ref={tabsRef}>
                    {casinoTabsData.map((casinoTabsData, idx) => {
                      return (
                        <li
                          key={idx}
                          onClick={() => {
                            setActiveSectioon(casinoTabsData?.key);
                          }}
                          className={
                            casinoTabsData?.key === activeSection && "active"
                          }
                        >
                          <div className="img-box">
                            <img
                              src={casinoTabsData?.img}
                              alt={casinoTabsData?.name}
                            />
                          </div>
                          <span>{casinoTabsData?.name}</span>
                        </li>
                      );
                    })}
                  </ul>
                  {/* <div className="btn-box">
                <Button
                  variant="primary"
                  className="nex-btn"
                  onClick={() => handleTabsScroll("next")}
                >
                  <img src={NextBack} alt="next game" />
                </Button>
              </div> */}
                </div>

                <div className="search-box">
                  {/* <GamesSearchModal /> */}
                  <div className="searchGames">
                    <input
                      placeholder="Search"
                      onChange={(e) => handleSearch(e?.target?.value)}
                    />
                    <img src={Search} alt="search" />
                  </div>
                </div>
              </div>

              {searchArray?.length == 0 ? (
                <div>
                  {activeSection === AllKey ? (
                    <div>
                      {/* All games listing */}
                      {casinoTabsData
                        ?.filter((f) => f?.key !== AllKey)
                        .map((tab, idx) => {
                          return (
                            <div
                              className="container games-warpper mt-5"
                              key={idx}
                            >
                              <div className="games_header">
                                <div className="title">
                                  <img src={PlayIcon} alt="play game" />
                                  <h2 className="my-0 ms-2 me-3">
                                    {tab?.name}
                                  </h2>
                                </div>
                                <div className="btns-group">
                                  <div className="nex-back d-none d-md-flex">
                                    <Button
                                      variant="primary"
                                      className="back-btn mx-0"
                                      onClick={() =>
                                        handleScroll(tab.key, "back")
                                      }
                                    >
                                      <img src={NextBack} alt="back game" />
                                    </Button>
                                    <Button
                                      variant="primary"
                                      className="nex-btn"
                                      onClick={() =>
                                        handleScroll(tab.key, "next")
                                      }
                                    >
                                      <img src={NextBack} alt="next game" />
                                    </Button>
                                  </div>
                                  <Button
                                    onClick={() =>
                                      navigate(`/casino-provider/${tab?.key}`)
                                    }
                                  >
                                    Show All
                                  </Button>
                                </div>
                              </div>

                              <div
                                className="game-list mt-3"
                                ref={(el) =>
                                  (gameListRefs.current[tab.key] = el)
                                }
                              >
                                {tab?.key !== "alls" &&
                                  Object.values(casinoPageData?.[tab?.key]).map(
                                    (childObj) => {
                                      return Object.values(childObj).map(
                                        (game, idx) => {
                                          return (
                                            <div
                                              className="game"
                                              key={`${idx}_${game?.name?.replace(
                                                " ",
                                                "_",
                                              )}`}
                                              onClick={() =>
                                                handleRedirection(game)
                                              }
                                            >
                                              <div className="img-box">
                                                <img
                                                  src={game?.imgUrl || ""}
                                                  alt={game?.alt}
                                                />
                                                <div className="overlay">
                                                  <img
                                                    src={PlayIcon}
                                                    alt="play game"
                                                  />
                                                </div>
                                              </div>
                                              <h3 className="name mt-3">
                                                {game?.name}
                                              </h3>
                                            </div>
                                          );
                                        },
                                      );
                                    },
                                  )}
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  ) : (
                    <div>
                      {/* Specific provider listing */}
                      <div className="container games-warpper mt-5">
                        <div className="games_header">
                          <div className="title">
                            <img src={PlayIcon} alt="play game" />
                            <h2 className="my-0 ms-2 me-3">
                              {getTabDetails(activeSection)?.name}
                            </h2>
                          </div>
                          <div className="btns-group">
                            <div className="nex-back d-none d-md-flex">
                              <Button
                                variant="primary"
                                className="back-btn mx-0"
                                onClick={() => scrollGameList("back")}
                              >
                                <img src={NextBack} alt="back game" />
                              </Button>
                              <Button
                                variant="primary"
                                className="nex-btn"
                                onClick={() => scrollGameList("next")}
                              >
                                <img src={NextBack} alt="next game" />
                              </Button>
                            </div>
                            <Button
                              onClick={() =>
                                navigate(
                                  `/casino-provider/${
                                    getTabDetails(activeSection)?.key
                                  }`,
                                )
                              }
                            >
                              Show All
                            </Button>
                          </div>
                        </div>

                        <div className="game-list mt-3" ref={gameListRef}>
                          {casinoPageData?.[activeSection] &&
                            Object.values(casinoPageData?.[activeSection])?.map(
                              (childObj) =>
                                Object.values(childObj).map((game, idx) => {
                                  return (
                                    <div
                                      className="game"
                                      key={`${idx}_${game?.name?.replace(
                                        " ",
                                        "_",
                                      )}`}
                                      onClick={() => handleRedirection(game)}
                                    >
                                      <div className="img-box">
                                        <img
                                          src={game?.imgUrl || ""}
                                          alt={game?.alt}
                                        />
                                        <div className="overlay">
                                          <img src={PlayIcon} alt="play game" />
                                        </div>
                                      </div>
                                      <h3 className="name mt-3">
                                        {game?.name}
                                      </h3>
                                    </div>
                                  );
                                }),
                            )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div className="container games-warpper mt-5">
                  <div className="game-list all-games">
                    {searchArray?.map((game, idx) => {
                      return (
                        <div
                          className="game"
                          key={`${idx}_${game?.name?.replace(" ", "_")}`}
                          onClick={() => handleRedirection(game)}
                        >
                          <div className="img-box">
                            <img src={game?.imgUrl || ""} alt={game?.alt} />
                            <div className="overlay">
                              <img src={PlayIcon} alt="play game" />
                            </div>
                          </div>
                          <h3 className="name mt-3">{game?.name}</h3>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </main>

      {/* {!isAuth ? <BeforeLoginFooter /> : <Footer />} */}
    </>
  );
};

export default Casino;
